import React from 'react';

export default function ConfirmDialog({open, message, title, yes_text, no_text, on_yes, on_no}) {
	
	const handleClose = ( is_yes ) => {
		if(is_yes){ 
			on_yes();
		} else {
			on_no();
		}
	};
  
  if (!open) return null;

	return (
	  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
		<div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden border border-gray-200 dark:border-gray-700">
		  <div className="px-6 py-4 border-b dark:border-gray-700">
		    <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h2>
		  </div>
		  <div className="px-6 py-4 text-sm text-gray-600 dark:text-gray-300">
		    {message}
		  </div>
		  <div className="px-6 py-4 flex justify-end gap-2 border-t dark:border-gray-700">
			<button 
			  onClick={() => handleClose(false)} 
			  className="px-4 py-2 text-sm rounded border dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800"
			>
				{no_text}	
			</button>
			<button 
			  onClick={() => handleClose(true)} 
			  className="px-4 py-2 text-sm rounded bg-[#880e4f] text-white hover:bg-[#6b0b3f]"
			>
			  	{yes_text}
			</button>
		  </div>
		</div>
	  </div>
	);
  }